import React from 'react';
import { connect } from 'react-redux';
import { AppSidebarNav, MessagesComponent } from 'Components';
import { clearSidebarMessages } from 'Common/UI/state/actions';
import { getBuildDate, getSidebarDisplay } from 'State/selectors';

class AppSidebarContainer extends React.Component {
  componentDidMount() {
    this.props.clearSidebarMessages();
  }

  render() {
    const { sidebarDisplay, buildDate } = this.props;

    return (
      sidebarDisplay && (
        <aside id="app-sidebar" className="app-sidebar">
          <div className="app-sidebar--content">
            <AppSidebarNav />

            <div className="app-sidebar--info">
              MealsPlusWeb built at{' '}
              <div style={{ whiteSpace: 'pre' }}>{buildDate}</div>
            </div>
          </div>
          <MessagesComponent />
        </aside>
      )
    );
  }
}

const mapStateToProps = state => ({
  sidebarDisplay: getSidebarDisplay(state),
  buildDate: getBuildDate(state),
});

const mapDispatchToProps = { clearSidebarMessages };

export const AppSidebar = connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(AppSidebarContainer);



// WEBPACK FOOTER //
// ./src/containers/app/Sidebar.js